<template>
    <v-container class="pa-0 ma-0" fluid style="background-color: #EEEEE7; height:100% ">
        <v-toolbar dense :color="'#FBFAF1'" style="min-height: 80px;">
            <v-spacer></v-spacer>
            <v-toolbar-title class="mt-6 text-center">
                <img src="../assets/logo7.svg" alt="Logo" style="height: 60px;">
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-row class="mt-10" v-if="caminos.length > 0">
            <v-col cols="3"></v-col>
            <v-col cols="6">
                <v-select background-color="white" v-model="selectedCamino" :items="caminos" item-text="titulo"
                    item-value="id" label="Selecciona un camino" outlined></v-select>
            </v-col>
            <v-col cols="3"></v-col>
        </v-row>

        <v-row class="mt-4" v-if="agencias.length > 0">
            <v-col cols="3"></v-col>
            <v-col cols="6">
                <v-select background-color="white" v-model="selectedAgencia" :items="agencias" item-text="nombre"
                    item-value="identificador" label="Selecciona la agencia de origen" outlined></v-select>
            </v-col>
            <v-col cols="3"></v-col>
        </v-row>

        <v-row class="mt-4" v-if="caminos.length > 0">
            <v-col cols="3"></v-col>
            <v-col cols="6">
                <v-select background-color="white" v-model="selectedLanguage" :items="languages" item-text="language"
                    item-value="language" label="Selecciona el idioma" outlined></v-select>
            </v-col>
            <v-col cols="3"></v-col>
        </v-row>

        <v-row class="mt-4 mb-6" justify="center" v-if="caminos.length > 0">
            <v-chip link @click="selectedCamino && selectedLanguage? _irACentroReservas() : null" large class="ma-2 px-8 mr-8 hover-color"
                :color="miColorAzul" :text-color="miColorNaranja"
                style="font-size: 1.2rem;">
                Ir al Formulario
                <v-icon size="2rem" right>mdi-arrow-right</v-icon>
            </v-chip>
        </v-row>

    </v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    data() {
        return {
            selectedCamino: null,
            selectedAgencia: "web",
            selectedLanguage: "ES",

            miColorNaranja: '#FF9C00',
            miColorAzul: '#191970',

        };
    },
    computed: {
        ...mapState("caminos", ["caminos", "agencias", "languages"]),
    },
    mounted() {
        this._getCaminos();
        this._getAgencias();
    },
    methods: {
        ...mapActions("caminos", ["getCaminos", "getAgencias"]),


        async _getCaminos() {
            let res = await this.getCaminos();
        },

        async _getAgencias() {
            let res = await this.getAgencias();
        },

        _irACentroReservas() {
            this.$router.push({
                name: 'central_reservas',
                params: {
                    admin: 'adm',
                    camino_id: this.selectedCamino,
                    language: this.selectedLanguage,
                    agencia: this.selectedAgencia,
                }
            });
        },






    },
};
</script>

<style scoped></style>
